// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--Bz_or","text":"_93444fe79c--text--ila_s"};